


































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import dialogComp from '@/components/dialog/index.vue';
import { Button } from 'mint-ui';
import giftDialog from '../gift/gift';

@Component<VBANNER>({
  components: {
    dialogComp,
    'mt-button': Button,
  },
})
export default class VBANNER extends Vue {
  public tipType: number = 0; /* 0是已参与过活动，1是未中奖 */
  public tipError: string = '';
  public giftTip: string = '';
  public visible: boolean = false;
  public list: any = [];
  public loading:boolean = false;
  public show() {
    (this.$refs.dialog as any).show();
    this.getMyPrize();
  }
  public upload(item:any) {
    giftDialog({
      giftTip: item.prizeCode,
      copyText: item.id,
      callback:(done:any)=>{
        done();
        this.getMyPrize();
      }
    });
  }
  public getMyPrize() {
    (this as any).$axios.get('/commonly/getMyPrzie').then((res: any) => {
      let result:any = [];
      res.data.forEach((item:any)=>{
        if(item.prizeCode != 'THANKS'){
          result.push(item)
        }
      })
      this.list = result;
      this.loading = true;
    });
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public goUrl() {
    location.href =
      'https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong';
  }
  public callback() {}
  public goLottery() {
    this.callback();
    this.close();
  }
}
